import { render, staticRenderFns } from "./password_reset.vue?vue&type=template&id=200e9a8a&scoped=true&"
import script from "./password_reset.vue?vue&type=script&lang=js&"
export * from "./password_reset.vue?vue&type=script&lang=js&"
import style0 from "./password_reset.vue?vue&type=style&index=0&id=200e9a8a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e9a8a",
  null
  
)

export default component.exports